/* Výdejní místo Zásilkovny (snippet tb-pickup).

   Knihovna Packety se stahuje až po kliknutí na tlačítko – stránka bez
   výběru místa ji vůbec nenačte. Vybrané místo se vepíše do pole jako
   „název (ID 1234)“: název přečte člověk, podle ID se místo dohledá
   v klientské sekci při podávání zásilky.

   Když se knihovna nenačte nebo zákazník mapu zavře, pole zůstává
   obyčejným textovým polem a místo jde napsat ručně.

   Snippet může být na stránce víckrát, i se svým <script>. Proto je vše
   v uzávěru a prvek se definuje jen jednou. */

(() => {
  const TB_PACKETA_LIB = 'https://widget.packeta.com/v6/www/js/library.js';
  let tbPacketaLoading = null;

  function tbLoadPacketa() {
    if (window.Packeta && window.Packeta.Widget) return Promise.resolve();
    if (tbPacketaLoading) return tbPacketaLoading;
    tbPacketaLoading = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = TB_PACKETA_LIB;
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => {
        tbPacketaLoading = null;
        reject(new Error('Packeta widget se nenačetl'));
      };
      document.head.appendChild(script);
    });
    return tbPacketaLoading;
  }

  class TbPickup extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-tb-pickup-input]');
      this.button = this.querySelector('[data-tb-pickup-open]');
      if (!this.input || !this.button || !this.dataset.key) return;
      this.button.addEventListener('click', () => this.open());
    }

    open() {
      this.button.disabled = true;
      tbLoadPacketa()
        .then(() => {
          window.Packeta.Widget.pick(this.dataset.key, (point) => this.pick(point), {
            language: 'cs',
            country: 'cz',
          });
        })
        .catch(() => {
          /* Mapa není, zbývá ruční zápis. */
          this.input.focus();
        })
        .finally(() => {
          this.button.disabled = false;
        });
    }

    pick(point) {
      if (!point) return;
      const name = String(point.name || point.formatedValue || '').trim();
      if (!name) return;
      this.input.value = point.id ? `${name} (ID ${point.id})` : name;
      /* Formuláře kolem pole poslouchají input (stav objednávky, chybové
         zvýraznění) – programové vepsání ho samo nevyvolá. */
      this.input.dispatchEvent(new Event('input', { bubbles: true }));
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  if (!customElements.get('tb-pickup')) customElements.define('tb-pickup', TbPickup);
})();
